import styled from 'styled-components';
import Block from '@components/Layout/Block';
import {query} from '../../themes/fn';
import {font} from '@design/templateFns';
import ArcImg from '@components/ArcImg';
import AspectBox from '@components/Layout/AspectBox';
import { ResolvedImageData } from '@data/types';
import {ReactNode} from 'react';

export interface LocationDetailHeroProps {
  title: string;
  description: ReactNode;
  physicalLocation?: string;
  division: string;
  region: string;
  phone: string;
  locationImage?: ResolvedImageData,
  addressLine1: string;
  addressLine2?: string;
  addressLine3?: string;
  addressLine4?: string;
  imageAspectRatio?: number | number[];
}

/*** STYLING ***/

const Wrapper = styled.div`
  line-height: 1.5;
  margin-top: 40px;
  margin-left: 0;
  @media screen and (min-width: 1200px) {
    margin-left: 100px;
  }
  @media (${query.atLeast('tablet')}) {
  
    margin-top: 0;
  }
`;

const ImgWrapper = styled(AspectBox)`
  margin-bottom: 13px;
  margin-top: 40px;
  @media (${query.atLeast('tablet')}) {
    width: 743px;
    margin-top: 0;
  }
`;

const LocationContainer = styled.div`
  @media (${query.atLeast('tablet')}) {
    display: flex;
    justify-content: space-between;
    gap: 100px;
  }
`;

const LocationDetailBlock = styled.div`
  width: 100%;

  @media (${query.atLeast('tablet')}) {
    width: 880px;
  }
  
`;

const Header = styled.h1`
  ${font('headline-xxl')};
  margin-top: 0;
  margin-bottom: 35px;
  @media (${query.atLeast('tablet')}) {
    margin-bottom: 52px
  }
`;

const Label = styled.div`
  ${font('headline-xs')};
  margin-top: 25px;
  margin-bottom: 7px;
`;

const InfoText = styled.div`
  ${font('body-lg-regular')};
`;

const DescriptionText = styled.div`
  margin-top: 35px;
  ${font('body-lg-regular')};

  @media (${query.atLeast('tablet')}) {
    margin-top: 52px;
  }
`;

export const LocationDetailHero = ({
  title,
  description,
  division,
  region,
  phone,
  physicalLocation,
  addressLine1,
  addressLine2,
  addressLine3,
  addressLine4,
  locationImage,
  imageAspectRatio =  1.5,
}: LocationDetailHeroProps): JSX.Element => {
  
  return (
    <Block >
      <Wrapper>
        <LocationContainer>
          <LocationDetailBlock>
            <Header>{title}</Header>
            <Label>Physical Location</Label>
            <InfoText>{physicalLocation}</InfoText>
            <Label>Region</Label>
            <InfoText>{region}</InfoText>
            <Label>Division</Label>
            <InfoText>{division}</InfoText>
            <Label>Address</Label>
            <InfoText >
              <span>{addressLine1}</span>
            </InfoText>
            {addressLine2 && (
              <InfoText>
                {addressLine2}
              </InfoText>
            )}
            {addressLine3 && (
              <InfoText>
                {addressLine3}
              </InfoText>
            )}
            {addressLine4 && (
              <InfoText>
                {addressLine4}
              </InfoText>
            )}
            {phone && (
              <>
                <Label>Phone</Label>
                <InfoText>
                  {phone}
                </InfoText>
              </>
            )}
            {description && (
              <DescriptionText>
                {description} 
              </DescriptionText>
            )}
          </LocationDetailBlock>
            {locationImage && (
              <ImgWrapper ratio={imageAspectRatio}>
                <ArcImg
                  alt={title}
                  imageData={locationImage}
                  sizes={['50vw', null, '600px', '743px']}
                  data-aspect={imageAspectRatio}
                />
              </ImgWrapper>
            )}
        </LocationContainer>    
      </Wrapper>
    </Block>
  );
};